export const COMMENTAIRES = "Commentaires";
export const ANCIENNE_VALEUR = "Ancienne valeur";
export const NOUVELLE_VALEUR = "Nouvelle valeur";
export const BOOLEAN_TRUE_LABEL = "Oui";
export const BOOLEAN_FALSE_LABEL = "Non";
export const BIGBAG = "Big-bag / GRV";
export const DEPOT_BAG = "Dépôt-bag";
export const PALETTE_FILME = "Palette filmée";
export const SAC_RENFORCE = "Sac renforcé";
export const CONTENEUR_BAG = "Conteneur-bag";

export const BOITE_CARTON = "Caisse(s) en carton avec sac en plastique";
export const BOITE_PERFORANTS =
  "Boîte(s) et Mini-collecteurs pour déchets perforants";
export const GRAND_EMBALLAGE = "Grand(s) emballage(s)";
export const GRV = "Grand(s) récipient(s) pour vrac";
export const FUT = "Fût(s)";

export const OTHER = "Autre(s)";
export const MODAL_ARIA_LABEL_CONSULT = "Consultation d'une révision";
export const MODAL_ARIA_LABEL_UPDATE = "Gestion d'une révision";
export const MODAL_TITLE_UPDATE = "Gérer la révision du";
export const MODAL_TITLE_CONSULT = "Consulter les révisions du";
export const MODAL_TITLE_DELETE = "Annuler la révision du";

export const CAN_BE_CANCELLED_LABEL = "Annuler le bordereau";
export const CANCELATION_MSG = `Si votre demande d'annulation est approuvée, ce bordereau passera au statut Annulé pour tous les acteurs du bordereau.`;
export const CANCELATION_NOT_POSSIBLE_MSG = `Impossible d'annuler ce bordereau. Il est à un statut trop avancé.`;
export const CANCELATION_NOT_POSSIBLE_FOR_APPENDIX1_MSG = `Impossible d'annuler un bordereau de tournée dédiée à partir du moment où au moins une Annexe 1 a été signée par le transporteur.`;
export const TITLE_REQUEST_LIST = "Demander une révision du ";
export const DENOMINATION_USUELLE = "Dénomination usuelle du déchet";
export const NOUVELLE_DENOMINATION_USUELLE =
  "Nouvelle dénomination usuelle du déchet";
export const NOUVEAU_POIDS_EN_TONNES = "Nouveau poids en tonnes";
export const CODE_TRAITEMENT = "Code de traitement D/R";
export const NOUVEAU_CODE_TRAITEMENT = "Nouvelle valeur du code de traitement";
export const DESCRIPTION_TRAITEMENT = "Description du traitement";
export const NOUVELLE_DESC_TRAITEMENT = "Nouvelle description du traitement";
export const CODE_DECHET = "Code déchet";
export const NOUVEAU_CODE_DECHET = "Nouveau code déchet";
export const POP = "Contient des polluants organiques persistants";
export const NOUVEAU_POP =
  "Le déchet contients des polluants organiques persistants";
